import { render } from "./App.vue?vue&type=template&id=c16a19a6"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=c16a19a6&lang=scss"
script.render = render

export default script